import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'projects.list.pagination', {});
export const getFilters = (state) => get(state, 'projects.list.filters', {});

export const getProjectsIds = (state) => get(state, 'projects.list.result.projects', []);
export const getProjects = (state) => get(state, 'projects.list.entities.projects', []);

export const getIsLoading = (state) => get(state, 'projects.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'projects.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'projects.form.isFetching', false);
export const getIsFetchingConfig = (state) => get(state, 'projects.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'projects.form.isSaving', false);
export const getEditing = (state) => get(state, 'projects.form.editing', false);

export const getVisibleProjects = createSelector([getProjectsIds, getProjects], (ids, projects) =>
  ids.map((id) => projects[id]).filter((project) => !project.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/selectors/projects_selectors.js